export default {
    SET_META_WHATSAPP_AUTH(state, data) {
        state.metaWhatsappAuth = data
    },
    SET_META_WHATSAPP_CONNECTING(state, val) {
        state.metaWhatsappConnecting = val
    },
    SET_META_WHATSAPP_ERROR(state, val) {
        state.metaWhatsappError = val
    },
}


// WEBPACK FOOTER //
// ./src/modules/metaWhatsappApi/mutations.js